/**
 * Trigger a browser download of an in-memory string as a file.
 *
 * Consolidates the Blob → anchor-click → revoke dance that's been
 * inlined ad-hoc across the codebase (basketIoService, AllAllocationsPage,
 * promotionsService). New download sites should call this helper instead
 * of re-rolling the pattern.
 *
 * The 1-second delayed revoke is intentional: Safari starts the download
 * asynchronously after the click, and revoking the object URL too soon
 * cancels the in-flight download. Other browsers tolerate immediate
 * revoke but match the longer window without harm.
 */
export function downloadFile(
  filename: string,
  content: string,
  mimeType: string = 'text/plain',
): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
